<div
  class="product-card relative bg-white rounded-xl border-2 border-gold overflow-hidden transition-all duration-300 hover:shadow-xl flex flex-col h-full"
  #cardElement
>
  <!-- Product Image with Responsive Aspect Ratio -->
  <a
    [routerLink]="['/products', productCategory , productSlug]"
    (click)="onSelectProduct()"
    class="block w-full overflow-hidden relative aspect-w-3 aspect-h-4"
  >
    <img
      #productImage
      loading="lazy"
      [src]="product.detail?.galerie.data[0].img || 'https://via.placeholder.com/240x300'"
      [alt]="product.name"
      class="w-full h-full object-contain transition-transform duration-300 hover:brightness-110"
    >
    <div
      class="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 touch-none pointer-events-none"
    ></div>
  </a>

  <!-- Product Info with Flexible Layout -->
  <div class="p-2 sm:p-3 flex flex-col justify-between flex-grow">
    <!-- Brand (1 line) -->
    <span
      class="block text-xs sm:text-sm text-gray-600 font-medium uppercase tracking-wide h-4 sm:h-5 overflow-hidden"
    >
      {{ product.marque }}
    </span>

    <!-- Complete Name (2 lines fixed) -->
    <h3
    class="text-base sm:text-lg md:text-xl font-serif font-bold text-gray-900 leading-tight text-center h-12 sm:h-14 md:h-16 line-clamp-3 overflow-hidden"
  >
    {{ product.name }}
    </h3>

    <!-- Description (1 line fixed) -->
    <p *ngIf="product.description"
      class="text-xs sm:text-sm text-gray-500 italic h-4 sm:h-5 overflow-hidden"
    >
      {{ product.description  }}
    </p>
    

    <!-- Pricing and Button on Same Line with Stacked Prices -->
    <div class="flex items-center justify-between mt-1 sm:mt-2 space-x-1 sm:space-x-2">
      <!-- Pricing (Stacked Vertically) -->
      <div class="text-base sm:text-lg font-bold text-gray-900 flex-shrink-0">
        <!-- Regular Price (smaller and crossed out if it exists) -->
        <span
          *ngIf="product.priceNormal"
          class="text-xs sm:text-sm line-through text-gray-500 block"
        >
          {{ product.priceNormal * 13 | currency:'MAD' }}
        </span>
        <!-- Display Special Price if it exists, otherwise Regular Price -->
        <span
          [ngClass]="{'text-red-700': product.price}"
          class="text-base sm:text-lg block"
        >
          {{ (product.price ? product.price : product.priceNormal ) * 13 | currency:'MAD' }}
        </span>
      </div>

      <!-- Conditional Button (Minimized) -->
      <button
        *ngIf="!product.detail?.detailsPrix || product.detail?.detailsPrix.length === 0; else chooseButton"
        (click)="onAddToCart()"
        class="bg-gradient-to-r from-gold to-yellow-600 text-white font-serif text-xs sm:text-sm py-1 sm:py-2 px-2 sm:px-3 rounded-full hover:from-red-700 hover:to-red-600 transition-all duration-300"
      >
        Ajouter
      </button>
      <ng-template #chooseButton>
        <a
          [routerLink]="['/products', productCategory || 'product', productSlug, product.id]"
          class="bg-gradient-to-r from-gold to-yellow-600 text-white font-serif text-xs sm:text-sm py-1 sm:py-2 px-2 sm:px-3 rounded-full hover:from-red-600 hover:to-red-700 transition-all duration-300"
        >
          Choisir
        </a>
      </ng-template>
    </div>
  </div>
</div>
